/**
 * A4 — Tarjeta del Dashboard: lo que toca facturar ya y lo que vence este mes y el
 * siguiente. Cuenta lo mismo que Facturación → Pendientes (misma consulta).
 */
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Hourglass } from 'lucide-react'
import { api } from '../../lib/api'
import { formatCents } from '../../lib/money'
import type { PendingBillingResponse } from '@toga/shared'

export default function PendingBillingCard() {
  const [data, setData] = useState<PendingBillingResponse | null>(null)

  useEffect(() => {
    let alive = true
    api
      .get<PendingBillingResponse>('/billing/pending')
      .then((r) => alive && setData(r))
      .catch(() => alive && setData(null))
    return () => {
      alive = false
    }
  }, [])

  if (!data || (data.dueCount === 0 && data.upcomingCount === 0)) return null

  return (
    <Link
      to="/billing/pending"
      className="surface p-5 flex flex-wrap items-center gap-4 hover:border-toga-500/40 transition"
    >
      <div
        className={[
          'w-12 h-12 rounded-xl grid place-items-center',
          data.dueCount > 0 ? 'bg-amber-500/15 text-amber-300' : 'bg-toga-500/15 text-toga-300',
        ].join(' ')}
      >
        <Hourglass size={22} />
      </div>
      <div className="min-w-0 flex-1 basis-60">
        <div className="text-xs uppercase tracking-wider t-muted">Pendiente de facturar</div>
        <div className="text-2xl font-semibold t-primary mt-1 font-mono">
          {data.dueCount > 0 ? formatCents(data.dueBaseCents) : 'Al día'}
        </div>
        <div className="text-xs t-faint mt-1">
          {data.dueCount > 0
            ? `${data.dueCount} por facturar ya (base imponible)`
            : 'Nada vencido sin facturar'}
          {data.upcomingCount > 0 &&
            ` · ${data.upcomingCount} más este mes y el siguiente (${formatCents(data.upcomingBaseCents)})`}
        </div>
      </div>
      <span className="text-xs t-muted">Ver pendientes →</span>
    </Link>
  )
}
